import * as React from 'react';
export const filterSvg = React.forwardRef(function filterSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.7 9.201a.8.8 0 1 1 0 1.6H4.3a.8.8 0 1 1 0-1.6h3.4ZM9.501 5.2A.8.8 0 0 1 9.5 6.8l-7 .003a.8.8 0 1 1 .001-1.6l7-.003Zm1.699-4a.8.8 0 0 1 0 1.6L.8 2.804a.8.8 0 0 1 0-1.601L11.2 1.2Z',
    }),
  );
});
filterSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var filter = {
  category: 'icon',
  colorable: true,
  name: 'filter',
  svg: filterSvg,
};
